import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-view-permission',
  templateUrl: './view-permission.component.html',
  styleUrls: ['./view-permission.component.css']
})
export class ViewPermissionComponent implements OnInit {
  @Input() isBundle: boolean;
  displayPermission: boolean;
  redirectUrl: String;

  constructor() { }

  ngOnInit() {

    if (this.isBundle) {
      this.redirectUrl = "/Release-Bundles"
    } else {
      this.redirectUrl = "/Home"
    }

    setTimeout(() => {
      this.displayPermission = true;
    },
      2000);

  }


}
